export function DetailItem({ label, value }: { label: string; value: string | number | React.ReactNode }) {
  return (
    <div className="space-y-1">
      <div className="text-sm text-gray-500">{label}</div>
      <div className="text-sm font-medium text-gray-700">{value || "Tidak ada data"}</div>
    </div>
  );
}
